import React, { PureComponent } from "react";
import { Select, Radio, Checkbox, Button } from "element-react";
import { List,Input } from "antd";
import { Link } from "react-router-dom";

import Request from "../../networkReq/request";
import Http from "../../networkReq/http"

import add from "../../images/index/backadd.png";
import search from "../../images/search.png";
import minus from "../../images/index/backminus.png";

import "./index.scss";

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      objoptions: [{
        value: '1',
        label: '对象1'
      }, {
        value: '2',
        label: '对象2'
      }, {
        value: '3',
        label: '对象3'
      }, {
        value: '4',
        label: '对象4'
      }],
      classoptions: [{
        value: '1',
        label: '分类1'
      }, {
        value: '2',
        label: '分类2'
      }, {
        value: '3',
        label: '分类3'
      }, {
        value: '4',
        label: '分类4'
      }],
      objvalue: '',
      classvalue: '',
      radiovalue: '1',
      listData: [
        {id: 1,itemName: '信访进行申请'},
        {id: 2,itemName: '信访进行申请'}
      ],
      eventdata: [],
      showChildren: false,
      showid: 0,
      eventChildren: [],
      searchvalue : {serviceName: ''},
    };
  }


  componentDidMount() {
    const { location: { state } } = this.props;
    let params = {
      current: 1,
      size: 8,
      parentId: state.id,
    };
    return Http.get(Request.getHome(), params, obj => {
      console.log('obj', obj);
      if (obj.code == 200) {
        this.setState({
          eventdata: obj.data.records
        })
      }
    });
  }

  onChange(radiovalue) {
    this.setState({ radiovalue });
  }
  btnClick(id){
    this.props.history.push({pathname: '/entrance/xfapplication', query: {id: id}})
  }

  handleChildren = (id) => {
    const { showChildren, showid } = this.state;
    if (showChildren&&showid==id) {
      this.setState({
        showChildren: !showChildren,
        showid: id,
      })
    } else if (showChildren && showid != id) {
      let params = {
        current: 1,
        size: 1000,
        serviceId: id,
        itemStatus: 1,
      };
      return Http.get(Request.getEvent(), params, obj => {
        console.log('obj', obj);
        if (obj.code == 200) {
          this.setState({
            eventChildren: obj.data.records,
            showid: id,
          })
        }
      });
    }else {
      let params = {
        current: 1,
        size: 1000,
        serviceId: id,
        itemStatus: 1,
      };
      return Http.get(Request.getEvent(), params, obj => {
        console.log('obj', obj);
        if (obj.code == 200) {
          this.setState({
            eventChildren: obj.data.records,
            showChildren: !showChildren,
            showid: id,
          })
        }
      });
    }
  }

  handleSearch = () => {
    const { location: { state } } = this.props;
    const { searchvalue } = this.state;
    let params = {
      current: 1,
      size: 8,
      parentId: state.id,
      serviceName: searchvalue.serviceName
    };
    return Http.get(Request.getHome(), params, obj => {
      console.log('obj', obj);
      if (obj.code == 200) {
        this.setState({
          eventdata: obj.data.records
        })
      }
    });
  }

  handleInput = e => {
    const { value } = e.target;
    let searchvalue = this.state.searchvalue;
    searchvalue.serviceName = value;
    this.setState({
      searchvalue: searchvalue
    })
  }

  render() {
    const { location: { state } } = this.props;
    const { objoptions, classoptions, listData, eventdata, showChildren, eventChildren, showid } = this.state;
    console.log('eventChildren',eventChildren)
    return (
      <div className="protection">
        <div className="header">
          <text className="title">{state.name}</text>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <text className="subtitle">说明：标记" * " 的为低频事项</text>
        </div>
        <div className="searchOpt">
          {/* <Select className="select" value={this.state.objvalue} placeholder="服务对象">
            {
              objoptions.map(el => {
                return <Select.Option key={el.value} label={el.label} value={el.value} />
              })
            }
          </Select>
          <Select className="select classopt" value={this.state.classvalue} placeholder="主题分类">
            {
              classoptions.map(el => {
                return <Select.Option key={el.value} label={el.label} value={el.value} />
              })
            }
          </Select>
          <Radio.Group value={this.state.radiovalue} onChange={this.onChange.bind(this)}>
            <Radio value="1">全部</Radio>
            <Radio value="2">即办件</Radio>
            <Radio value="3">零跑腿</Radio>
          </Radio.Group>
          <Checkbox className="checkbox">可在线申办</Checkbox> */}
          <Input style={{ width: '385px', marginLeft: '62%', height: 35 }} placeholder="输入事项名称关键词" onChange={(e) => this.handleInput(e)} />
          <div className="search" onClick={() => this.handleSearch()}><img src={search} alt=""></img></div>
        </div>
        <List
          itemLayout="vertical"
          size="large"
          pagination={{
            onChange: page => {
              console.log(page);
            },
            pageSize: 5,
          }}
          style={{ marginBottom: 15,minHeight: 350}}
          //, marginTop: 15
          className="elist"
          dataSource={eventdata}
          renderItem={item => (
            <List.Item
              key={item.id}
              style={{ padding: 0, paddingBottom: 16, display: 'block', borderBottom: 'none' }}
              // paddingTop: 16, 
            >
              <div className="searchOpt listheader" onClick={() => this.handleChildren(item.id)}>
                {showChildren&&showid==item.id ? <img className="icon" src={minus} alt="" /> : <img className="icon" src={add} alt="" />}
                <text>{item.serviceName}</text>
              </div>
              <div style={{width: '100%',marginBottom: '15px', display: showChildren&&showid==item.id ? "block" : "none"}}>
                <List
                  itemLayout="vertical"
                  size="large"
                  dataSource={eventChildren}
                  renderItem={item => (
                    <List.Item
                      key={item.id}
                      actions={[<Button style={{borderRadius: '7%',borderColor: '#1073B7',color: '#1073B7'}} onClick={ this.btnClick.bind(this, item.id)}>办事指南</Button>, <Button disabled={true} style={{borderRadius: '7%'}}>在线办理</Button>]}
                    >
                      {item.itemName}
                    </List.Item>
                  )}
                />
              </div>
            </List.Item>
          )}
        >
        </List>
      </div>
    );
  }
}
